import { BaseMapper } from '@ps/utils';

import { NotificationActionResultDto } from '../dtos/notification-action-result.dto';
import { NotificationActionApplyResult } from '../../state/notification.model';

export class NotificationActionResultMapper extends BaseMapper<
  NotificationActionResultDto,
  NotificationActionApplyResult
> {
  public fromDto(
    resultDto: NotificationActionResultDto,
  ): NotificationActionApplyResult {
    return {
      state: resultDto.state,
      resultLabel: resultDto.resultLabel ?? null,
      appliedBy: resultDto.appliedBy ?? null,
      // ISO 8601 on the wire, epoch ms in state.
      appliedAt: resultDto.appliedAt
        ? new Date(resultDto.appliedAt).getTime()
        : null,
    };
  }
}
